import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Adempimento } from '../../../common/models/adempimento';
import { ScadenzaResponse } from '../../../common/models/dto/scadenza-response';
import { CssClassMapping } from '../../configuration/css-class-mapping';
import { FrontEndMapping } from '../../configuration/front-end-mapping';

import { ServicePathsSettings } from '../../configuration/service-paths-settings';
import { UrlSettingsCore } from '../../configuration/url-settings-core';
import { ModalNotifyService } from '../../services/modal-notify.service';
import { OperationsService } from '../../services/operations.service';
import { ViewManagerService } from '../../services/view-manager-service';
import { DialogService } from '../dialog/dialog.service';
import { ScadenzaEvadiComponent } from 'src/app/common/components/fascicolo/scadenza-evadi/scadenza-evadi.component';
import { ConfirmModalComponent } from '../dialog/components/confirm-modal/confirm-modal.component';

declare var getFascicoloMapSync;

@Component({
    selector: '[adempimenti-inevasi-list]',
  templateUrl: 'adempimenti-inevasi-list.component.html',
})

export class AdempimentiInevasiListComponent implements OnInit {
  @Input() viewOption: boolean = false;                         // settato a false temporaneamente manca integrazione metodi di rinvio/evadi
  @Input() adempimenti: Adempimento[] = [];
  @Input() slice: number;
  @Output() onReturn: EventEmitter<void> = new EventEmitter<void>();
  @Output() rinvia: EventEmitter<Adempimento> = new EventEmitter<Adempimento>();
  private subscriptionEvadi: Subscription;



  constructor(
    private viewManager: ViewManagerService, 
    protected operationService: OperationsService, 
    private router: Router, 
    private frontEndMapping: FrontEndMapping, 
    private modalNotifyService: ModalNotifyService,
    private dialog: DialogService
  ) {}

  ngOnInit() {
    for (var i = 0; i < this.adempimenti.length; i++) {
      let dateObj = new Date();
      dateObj.setHours(0, 0, 0, 0);
      let date = dateObj.getTime();
      let giorniRitardo = Math.ceil((date - this.adempimenti[i].dataScadenza) / (1000 * 60 * 60 * 24));
      if (giorniRitardo > 0) {
        this.adempimenti[i].giorniRitardo = giorniRitardo;
      }
    }
    if (this.slice > 0 && this.slice < this.adempimenti.length) {
      this.adempimenti =  this.adempimenti.slice(0, this.slice);
    }
  }

  goToSezScadenza(idTipoFascicolo: string, idTipoPratica: string, idFascicolo: string) {
      // let nomePraticaFE = FrontEndMapping.tipiPratica[Number(idTipoPratica)];
      let nomePraticaFE = '';
      this.frontEndMapping.getListTipiPratica(idTipoPratica).subscribe(res => {
        nomePraticaFE = res;
      });
      // let nomeFascicoloFE = FrontEndMapping.tipiFascicolo[Number(idTipoFascicolo)];
      let nomeFascicoloFE = '';
      this.frontEndMapping.getListTipiFascicolo(idTipoFascicolo).subscribe(res => {
        nomeFascicoloFE = res;
      });
      localStorage.setItem('fromAdempimenti', 'true');
      this.router.navigate(['/fascicolo/' + nomePraticaFE + '/' + nomeFascicoloFE + '/' + UrlSettingsCore.URL_VISUALIZZA_SEZIONE_SCADENZARIO + '/' + idFascicolo]);
  }

  evadiAdempimento(adempimento){
    const ref = this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: "Sei sicuro di voler evadere evadere l'adempimento selezionato? ?",
        },
        style: { width: "30%" },
        title: "Conferma",
      }
    })

    const sub = ref.afterClosed.subscribe( event =>
      {
        if(event.modalEvent){
          this.openDialogEvadi(event.modalEvent, adempimento.id);
        }
        sub.unsubscribe();
      });
  }

  openDialogEvadi(result: boolean, idScadenza: string) {
    
    const ref = this.dialog.open(ScadenzaEvadiComponent, {
      data: {
        style: {
          width: '50%',
        },
        idAdempimento: idScadenza,
        title: 'Evadi adempimento',
      }
    });
    ref.afterClosed.subscribe((event) => {
      if(!event || event.closeEvent) return;
      if(event.dataEvasione) {
        let payload = {
          dataEvasione: event.dataEvasione, 
          motivoEvasione: event.motivoEvasione
        };
        this.executeEvasione(result, idScadenza, payload)
      }
    });
  }

  executeEvasione(result: boolean, idScadenza: string, payload) {
    if (result) {
     this.operationService.evadiAdempimentoParams(ServicePathsSettings.URL_EVADI_ADEMPIMENTO, idScadenza, payload).
       subscribe(response => this.resultEvadi(response));
    }
    if (this.subscriptionEvadi) {
      this.subscriptionEvadi.unsubscribe();
    }
  }

  rinviaAdempimento(adempimento){
    this.rinvia.emit(adempimento);
  }

  resultEvadi(response: ScadenzaResponse) {
    if (response.returnCode === 'OK') {
      var ind = this.adempimenti.findIndex(a => a.id === response.scadenza.id);
      this.adempimenti.splice(ind, 1);
      this.viewManager._adempimentiInevasi.next({param: response, timeOut: false});
      this.onReturn.emit();
    }
  }

  getClassNameTipoScadenza(id: string) {
    return CssClassMapping.cssTipoScadenza[id];
  }

  getClassNameTipoPriorita(id: string) {
    return CssClassMapping.cssNameTipoPriorita[id];
  }

  getClassColorTipoPriorita(id: string) {
    return CssClassMapping.cssColorTipoPriorita[id];
  }

}
